import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IStyleProps {
  selected?:boolean;
};


export const Root = styled.div`
    padding: 0px 0px 0px 0px;
    background-color: #ffffff;
    overflow-y: hidden;
    overflow-x: hidden;
    
`;

export const VersionsContainer = styled.div`
  box-sizing: border-box;
  margin-top:10px;
  width: 100%;
  position: relative;
  max-height: calc(100vh - 230px);
  overflow-y: auto;
  overflow-x: hidden;
  padding-right:5px;
 
`

export const Title = styled.div`
  width: 82%;
  height: 40px;
  text-align: left;
  vertical-align: middle;
  margin-left:20px;
  margin-top:30px; 
  font-family: Roboto;
  font-size: 18px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;  
  color: #204078;  
`

export const Version = styled.div`
    width: 100%;
    padding:15px;
    font-family: Roboto;
    font-size: 15px;    
    font-stretch: normal;
    font-style: normal;
    font-weight: 600;  
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #8d8d8d; 
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor:pointer;
    &:hover {
      background-color: rgba(18, 36, 66, 0.05);      
    }    
    background-color: ${(props: IStyleProps) => ( (props.selected??false)?'rgba(18, 36, 66, 0.1)': '')};  
`;

export const Header = styled.div`
    display:flex;
    flex-direction: row;
    width:100%;        
`;


export const IconContainer = styled.div`
    margin-top:28px;
    height: 40px;
    cursor:pointer;
`;
